<template>
    <div style="background:#f0f9fd;">
        <v-cookie></v-cookie>
        <div class="lefttop"><span></span>云验证</div>    
        <dl class="leftmenu">
            <dd v-for="parent,index in parentList">
                <div class="title" @click="activeM(parent,index)"><span><img :src="parent.img" /></span>{{parent.name}}</div>
                <ul class="menuson" v-show="parent.isOpen">
                    <li v-for="child,cindex in parent.childList" :class="{active:child.isActive}" @click="activeFun(child)">
                        <cite></cite><a :href="child.url" target="rightFrame">
                            {{child.name}}
                        </a>
                    </li>
                </ul>
            </dd>
        </dl>
    </div>
</template>
<script>
import txlIco from '../assets/images/leftico01.png';
import ktIco from '../assets/images/leftico02.png';
import epIco from '../assets/images/leftico03.png';
import smsIco from '../assets/images/leftico04.png';
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            account:'',
            cpid:3,
            agentCode:'10',
            productCode:'',
            isVoiceCode:0,
            parentList:[{
                name:'通讯录',
                img: txlIco,                
                isOpen:true,
                childList:[
                    {name:'通讯录',url:'/txlcont', isActive: false},
                    {name:'添加联系人',url:'/txladd', isActive: false},
                    /*{name:'批量导入',url:'/txlupload', isActive: false},*/
                    {name:'批量导入',url:'/txlupload2', isActive: false},
                    {name:'通讯录组管理',url:'/txlgroup', isActive: false},
                ]
            },/*{
                name:'邮件管理',
                img: smsIco,
                isOpen:false,
                childList:[
                    {name:'发邮件',url:'/emailsend', isActive: false},
                    {name:'已发送邮件',url:'/emaillog', isActive: false},
                    {name:'邮件发送设置',url:'/emailconfig', isActive: false},
                    {name:'邮件发送帮助',url:'/emailhelp', isActive: false},
                ]
            },{
                name:'手机流量充值',
                img: smsIco,
                isOpen:false,
                childList:[
                    {name:'流量单充',url:'/llrecharge', isActive: false},
                    {name:'流量充值查询',url:'/llrechargelog', isActive: false},
                ]
            },*/{
                name:'日程和提醒',
                img: ktIco,
                isOpen:false,
                childList:[
                    {name:'提醒',url:'/remind', isActive: false},
                    {name:'记事代办/备忘录',url:'/memorandum', isActive: false},
                    {name:'提醒类型管理',url:'/remindtype', isActive: false},
                ]
            },{
                name:'企业账号管理',
                img: epIco,
                isOpen:false,
                childList:[
                    {name:'企业账号管理',url:'/enterprise', isActive: false},
                ]
            },{
                name:'账户设置',
                img: smsIco,
                isOpen:false,
                childList:[
                    {name:'基本信息',url:'/personinfo', isActive: false},
                    {name:'密码设置',url:'/passwordset', isActive: false},
                    {name:'账户余额',url:'/account', isActive: false},
                    {name:'内容保证金',url:'/user106', isActive: false},
                    {name:'充值信息',url:'/chargeinfo', isActive: false},
                    {name:'充值抵用券',url:'/usercoupon',isActive:false},
                    {name:'业务订购',url:'/userpackage',isActive:false},
                    {name:'优惠券充值',url:'/uservoucher',isActive:false},
                ]
            },{
                name:'发票管理',
                img: epIco,
                isOpen:false,
                childList:[
                    {name:'发票申请',url:'/invoiceapply', isActive: false},
                    {name:'开票记录',url:'/invoicelog', isActive: false},
                    {name:'发票信息管理',url:'/invoiceinformationmanage', isActive: false},
                    {name:'邮寄地址管理',url:'/invoiceaddressmanage', isActive: false},
                ]
            }]
        }
    },
    mounted(){
        this.getData();
    },
    methods:{
        activeFun: function(data){
            this.parentList.forEach(function(obj){
                 obj.childList.forEach(function(cobj){
                    cobj.isActive = false;   
                });
            });
            
            data.isActive = !data.isActive;
        },
        activeM: function(data,selecIndex){
            this.parentList.forEach(function(obj,index){
                if(index != selecIndex)
                    obj.isOpen = false;
            });
            data.isOpen = !data.isOpen;
            $('body,html').animate({scrollTop:0},10);
        },
        getData(){
            let that = this;
            let data = {};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/main/leftmenu.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    let index = 1;
                    that.account = res.data.account;
                    that.cpid = res.data.cpid;
                    that.productCode = res.data.productCode;
                    that.agentCode = res.data.agentCode;
                    that.isVoiceCode = res.data.isVoiceCode;
                    if(that.productCode.indexOf(",10,")!=-1)
                    {
                        if(res.data.account == '2576003' || res.data.account == '2574281' || res.data.account == '2559470' || res.data.account == '2549240' || res.data.account == '2570343' || res.data.account == '2526578'){
                            that.parentList.splice(index, 0,{
                                name:'短信管理',
                                img: smsIco,
                                isOpen:false,
                                childList:[
                                    {name:'发送短信',url:'/smssend?mobile=&mobileNum=0', isActive: false},
                                    {name:'审核列表',url:'/smscheck', isActive: false},
                                    {name:'短地址群发',url:'/smsshortsend?mobile=', isActive: false},                                
                                    {name:'短地址群发结果',url:'/smsshorttask', isActive: false},  
                                    {name:'当天已发短信',url:'/smsmtdaylog', isActive: false},
                                    {name:'昨天前天已发短信',url:'/smsmtdaybeforelog', isActive: false},
                                    {name:'3天前已发短信',url:'/smsmtlog', isActive: false},
                                    {name:'珍藏信箱',url:'/smssavebox', isActive: false},
                                    {name:'草稿箱',url:'/smsdraftbox', isActive: false},
                                    {name:'群发库',url:'/smsconttxt', isActive: false},
                                    {name:'短信库',url:'/smsclassfiy', isActive: false},
                                    {name:'个性短信',url:'/smsgexing', isActive: false},
                                    {name:'手机号码整理工具',url:'/smstools', isActive: false},
                                    {name:'短信签名',url:'/smssign', isActive: false},
                                    {name:'异常短信',url:'/smsmtsenderror', isActive: false},
                                ]
                            })
                        }else{
                            that.parentList.splice(index, 0,{
                                name:'短信管理',
                                img: smsIco,
                                isOpen:false,
                                childList:[
                                    {name:'发送短信',url:'/smssend?mobile=&mobileNum=0', isActive: false},
                                    {name:'审核列表',url:'/smscheck', isActive: false},
                                    {name:'短地址群发',url:'/smsshortsend?mobile=', isActive: false},                                
                                    {name:'短地址群发结果',url:'/smsshorttask', isActive: false},                                
                                    {name:'收件箱',url:'/smsmo', isActive: false},
                                    {name:'当天已发短信',url:'/smsmtdaylog', isActive: false},
                                    {name:'昨天前天已发短信',url:'/smsmtdaybeforelog', isActive: false},
                                    {name:'3天前已发短信',url:'/smsmtlog', isActive: false},
                                    {name:'珍藏信箱',url:'/smssavebox', isActive: false},
                                    {name:'草稿箱',url:'/smsdraftbox', isActive: false},
                                    // {name:'收短信-通知设置',url:'/smsreachnotice', isActive: false},
                                    {name:'群发库',url:'/smsconttxt', isActive: false},
                                    {name:'短信库',url:'/smsclassfiy', isActive: false},
                                    {name:'个性短信',url:'/smsgexing', isActive: false},
                                    {name:'手机号码整理工具',url:'/smstools', isActive: false},
                                    {name:'短信签名',url:'/smssign', isActive: false},
                                    {name:'异常短信',url:'/smsmtsenderror', isActive: false},
                                ]
                            })
                        }
                        
                        index++;
                        
                        that.parentList.splice(index, 0,{
                            name:'视频短信管理',
                            img: smsIco,
                            isOpen:false,
                            childList:[
                                {name:'视频短信模板',url:'/videosmstemplate', isActive: false},
                                {name:'发送视频短信',url:'/videosmssend', isActive: false},                                
                                {name:'审核列表',url:'/smscheck', isActive: false},
                                {name:'发送日志',url:'/videosmslog', isActive: false},
                            ]
                        })
                        index++;
                    }
                    if(that.productCode.indexOf(",20,")!=-1)
                    {
                        that.parentList.splice(index, 0,{
                            name:'传真管理',
                            img: smsIco,
                            isOpen:false,
                            childList:[
                                {name:'发传真',url:'/faxsend', isActive: false},
                                {name:'传真审核列表',url:'/faxcheck', isActive: false},
                                {name:'传真发送列表',url:'/faxsendlog', isActive: false},
                                {name:'传真群发录',url:'/faxconttxt', isActive: false},
                            ]
                        })
                        index++;
                    }
                    // that.parentList.splice(index, 0,{
                    //     name:'号码认证',
                    //     img: epIco,
                    //     isOpen:false,
                    //     childList:[
                    //         {name:'号码认证申请',url:'/authenticationnumber', isActive: false},
                    //         {name:'号码认证管理',url:'/authenticationnumbermanage?status=', isActive: false},
                    //     ]
                    // })
                    that.parentList.splice(index, 0,{
                        name:'商标注册',
                        img: epIco,
                        isOpen:false,
                        childList:[
                            {name:'商标注册',url:'/brandreg', isActive: false},
                        ]
                    })
                    index++;
                    if(that.productCode.indexOf(",11,")!=-1)
                    {
                        that.parentList.splice(index, 0,{
                            name:'彩信管理',
                            img: smsIco,
                            isOpen:false,
                            childList:[
                                {name:'发送彩信',url:'/mmssend', isActive: false},
                                {name:'彩信审核',url:'/mmscheck', isActive: false},
                                {name:'草稿箱',url:'/mmsdraft', isActive: false},
                                {name:'已发彩信',url:'/mmssendlog', isActive: false},
                                {name:'珍藏彩信',url:'/mmssave', isActive: false},
                            ]
                        })
                        index++;
                    }
                    // if(that.productCode.indexOf(",31,")!=-1)
                    // {
                    //     that.parentList.splice(index, 0,{
                    //         name:'电话管理',
                    //         img: smsIco,
                    //         isOpen:false,
                    //         childList:[
                    //             {name:'号码设置',url:'/dialset', isActive: false},
                    //             {name:'点击通话',url:'/dialsend?mobile=', isActive: false},
                    //             {name:'电话消费记录',url:'/diallog', isActive: false},
                    //         ]
                    //     })
                    //     index++;
                    // }                    
                    if(1 == that.isVoiceCode)
                    {
                        that.parentList.splice(index, 0,{
                            name:'语音验证码管理',
                            img: smsIco,
                            isOpen:false,
                            childList:[
                                {name:'语音验证码日志',url:'/voicecodelog', isActive: false},
                            ]
                        })
                        index++;
                    }
                    if(res.data.account == '20582' || res.data.account == '2522280')
                    {
                        that.parentList.splice(index, 0,{
                            name:'云电销',
                            img: epIco,
                            isOpen:false,
                            childList:[
                                {name:'语音文件设置',url:'/managewavfile', isActive: false},
                                {name:'发起云电销',url:'/sendmarketvoice', isActive: false},
                                {name:'外呼记录',url:'/marketvoicedetailbill', isActive: false},
                            ]
                        })
                        index++;
                    }
                    if(that.agentCode == 0)
                    {
                        that.parentList.forEach(obj => {
                            if(obj.name == '企业账号管理'){
                                obj.childList.push({name:'子账号管理', url: '/enterpriseusermanage', isActive: false},
                                    {name:'充值划账记录', url: '/enterprisexpaysuccess', isActive: false})
                            }
                            
                        });
                    }
                    
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/left.vue